import { createSagaActionTypes } from "../../../utils/actionFactory";

export const RESET_PASS = "RESET_PASS";

export const actions = createSagaActionTypes("FORGOTTEN_PASS", [RESET_PASS]);
